import { GraphQLQuery } from '@settings/services/graphQLClient/GraphQLClient';
import gql from 'graphql-tag';

// Параметры удаления индивидуального предложения
export interface DeleteIndividualOfferQueryParams {
  id: string;
}

// Ответ на удаление индивидуального предложения
export interface DeleteIndividualOfferQueryResponse {
  data: boolean | null;
}

// Удаление индивидуального предложения. На бэке это query, а не mutation
export class DeleteIndividualOfferQuery implements GraphQLQuery<DeleteIndividualOfferQueryParams> {
  readonly query: any;

  readonly variables: DeleteIndividualOfferQueryParams;

  constructor(params: DeleteIndividualOfferQueryParams) {
    this.variables = {
      ...params,
    };

    this.query = gql`
      query __DELETE_INDIVIDUAL_OFFER__($id: ID!) {
        data: deleteIndividualOfferById(externalId: $id)
      }
    `;
  }
}
